export const GET_BANK_LIST = "GET_BANK_LIST";
export const POST_BANK = "POST_BANK";
export const SHOW_BANK = "SHOW_BANK";
export const UPDATE_BANK = "UPDATE_BANK";
export const DELETE_BANK = "DELETE_BANK";
export const UPDATE_STATUS_BANK = "UPDATE_STATUS_BANK";
export const UPDATE_MAINTENANCE_STATUS_BANK = "UPDATE_MAINTENANCE_STATUS_BANK";
export const DROPDOWN = "BANK_DROPDOWN";
